module.exports = __webpack_public_path__ + "static/nithin-e164fac763a7d4f471479ac183c35ae8.jpg";